import { ConnectError } from '@connectrpc/connect';
/**
 * Extracts a user-facing message from a failed API call.
 *
 * This replaces the `error instanceof ProjectApiError ? error.message : fallback`
 * pattern that was copied across the project dialogs. Those branches were
 * already dead wherever Connect was enabled: the Connect client never threw
 * ProjectApiError, so every failure silently took the generic branch and the
 * user lost the server's actual reason. Now that project data is Connect-only,
 * the check has to key on ConnectError or it never matches at all.
 *
 * ConnectError.message is prefixed with the code — "[invalid_argument] name is
 * required" — which is noise in a toast. rawMessage is the server's own text,
 * which is what a user can act on.
 */ export function apiErrorMessage(error, fallback) {
    if (error instanceof ConnectError) {
        return error.rawMessage || fallback;
    }
    if (error instanceof Error && error.message) {
        return error.message;
    }
    return fallback;
}
